import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export const addBatchStudentApi = async (
    url: string,
    batchId: string,
    userId: string,
    regId: string,
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.post(
            `${url}/BatchStudent/Create`,
            {
                batchId,
                userId,
                regId,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        )
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getBatchStudentsByBatchIdApi = async (
    url: string,
    batchId: string,
    pageNumber: number = 1,
    pageSize: number = 10
) => {
    const token = cookies.get('authToken');
    try {
        const response = await axios.get(
            `${url}/BatchStudent/GetByBatchId/${batchId}`,
            {
                params: {
                    pageNumber,
                    pageSize,
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data; // Return the response containing students and total count
    } catch (error) {
        console.error("Error fetching batch students:", error);
        throw error;
    }
};

export default addBatchStudentApi;